import React, { Component } from 'react'
import { Switch, withRouter, Route } from 'react-router-dom'

import { authorization } from '../../Module/Auth/Auth'

import { PrivateRoute } from '../../Config/Routing/auth'
import ChatV2 from '../../Containers/ChatV2/container/ChatV2'

class ChatRouterV2 extends Component {
  render() {
    return (
      <Switch>
        <Route path={this.props.match.url}>
          <PrivateRoute
            isRestricted={
              !authorization.isCityManager() || authorization.isSpy()
            }
          >
            <ChatV2 />
          </PrivateRoute>
        </Route>
      </Switch>
    )
  }
}

export default withRouter(ChatRouterV2)
